import React from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import {
  SentimentDissatisfied as SadIcon,
  Home as HomeIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "70vh",
      }}
    >
      <Paper
        elevation={0}
        sx={{
          py: 8,
          px: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          borderRadius: 3,
          maxWidth: 500,
          width: "100%",
          bgcolor: "background.paper",
          border: "1px dashed",
          borderColor: "divider",
        }}
      >
        <SadIcon sx={{ fontSize: 80, color: "primary.light", mb: 2 }} />

        <Typography variant="h4" color="primary" gutterBottom>
          Oops! Page Not Found
        </Typography>

        <Typography variant="body1" color="text.secondary" paragraph>
          We can't seem to find the page you're looking for. It might have been
          moved, deleted, or perhaps it never existed.
        </Typography>

        <Button
          variant="contained"
          color="primary"
          startIcon={<HomeIcon />}
          onClick={() => navigate("/")}
          sx={{ mt: 2 }}
        >
          Back to Dashboard
        </Button>
      </Paper>
    </Box>
  );
};

export default NotFound;
